export default [{
        name: 'launcher-article',
        path: '/launcher-article/:type',
        component: () =>
            import ('@/views/launcher-articles/index.vue'),
        meta: {
            title: '',
            shareArticle: true,
            qrcodeParams: {
                id: ':type',
                type: ''
            }
        }
    },
    {
        name: 'launcher-article-comment',
        path: '/launcher-articleComment',
        component: () =>
            import ('@/views/launcher-articles/Article-Comment/index.vue'),
        meta: {
            title: '时金投资',
            shareArticle: true
        }
    },
    {
        name: 'launcher-article-list',
        path: '/launcher-article-list/:type',
        component: () =>
            import ('@/views/launcher-articles/list.vue'),
        meta: {
            title: '',
            shareArticle: true,
            qrcodeParams: {
                type: ':type',
            }
        }
    },
    {
        name: 'teacher-info',
        path: '/teacher-info',
        component: () =>
            import ('@/views/teacher-info.vue'),
        meta: {
            title: '名师解盘',
            shareArticle: true
        }
    }
]